export default "__VITE_ASSET__BS3d2NLw__"